import { INameTranslation } from "../../model/translations/NameTranslation";
import { parseBooleanValue } from "../../../util";

const NameTranslationParamMapper = (item: INameTranslation) => {
  return {
    ...item,
    valid: parseBooleanValue(item.valid)
  };
};

export default NameTranslationParamMapper;
